import { FormlyFieldConfig } from '@ngx-formly/core';
import { IUpsertSoftDeletableRequest } from '../requests';

export class UpsertSoftDeletableModel implements IUpsertSoftDeletableRequest {
  isActive?: boolean;

  private constructor(request: IUpsertSoftDeletableRequest) {
    this.isActive = request.isActive;
  }

  static create(data: IUpsertSoftDeletableRequest): UpsertSoftDeletableModel {
    return new UpsertSoftDeletableModel(data);
  }

  static createDefault(): UpsertSoftDeletableModel {
    return UpsertSoftDeletableModel.create({});
  }

  getFormlyConfig(): FormlyFieldConfig[] {
    return [
      {
        key: 'isActive',
        type: 'toggle',
        templateOptions: {
          label: 'Active',
          required: false
        }
      }
    ];
  }
}
